import { fontSizes, fontWeights, lineHeight } from '@ohgoodlord/design-system'
import styled from 'styled-components'
import { colors } from '../../../common/colors'

export interface IncomeTypeChipProps {
  label: string
}

const IncomeTypeChipBox = styled.div`
  background: #f2f6f9;
  border: 1px solid #dfe6ec;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: ${fontSizes.xs};
  font-weight: ${fontWeights.normal};
  line-height: ${lineHeight};
  color: ${colors.greyscale2};
`

export const IncomeTypeChip = ({ label }: IncomeTypeChipProps) => {
  return <IncomeTypeChipBox>{label}</IncomeTypeChipBox>
}
